
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DatePicker from '@/components/date-picker.vue';
  import TimePicker from '@/components/TimePicker.vue';

  @Component({
    components: {TimePicker, DatePicker, Card},
  })
  export default class EventDetails extends Vue {
    public $refs!: {
      form: any,
    };
    @Prop({type: Object, default: null}) private event!: any;

    @Action('user/companies/read') private readCompanies!: () => Promise<any>;

    @Getter('common/rules/all') private rules!: any;
    @Getter('user/companies/all') private companies!: any;

    private loading: boolean = false;
    private deadlineDate: string = '';
    private deadlineTime: string = '';
    private date: string = '';
    private time: string = '';

    private async mounted() {
      this.loading = true;
      await this.readCompanies();

      const deadline = new Date(this.event.deadline);
      const date = new Date(this.event.date);
      this.deadlineDate = `${deadline.getDate()}.${deadline.getMonth() + 1}.${deadline.getFullYear()}`;
      this.date = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
      this.deadlineTime = `${deadline.getHours()}:${(deadline.getMinutes() < 10 ? '0' : '')}${deadline.getMinutes()}`;
      this.time = `${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '')}${date.getMinutes()}`;
      this.loading = false;
    }
  }
